import React, { useState } from 'react'
import { useSwipeable } from 'react-swipeable'
import './MobileSlider.css'
import clsx from 'clsx'
import { ArrowLeftIcon, ArrowRightIcon } from 'asterX-UI/Icons'
import Lightbox from 'react-18-image-lightbox'

const config = {
  delta: 10,
  preventScrollOnSwipe: false,
  trackTouch: true,
  trackMouse: false,
  rotationAngle: 0,
  swipeDuration: Infinity,
  touchEventOptions: { passive: true }
}

const MobilePhotoSlider = ({ photos = [], className, children }) => {
  const [currentIndex, setCurrentIndex] = useState(0)
  const [isOpen, setIsOpen] = useState(false)

  const handlers = useSwipeable({
    onSwiped: eventData => handleSwipe(eventData.deltaX),
    ...config
  })

  const handlePrev = () => {
    setCurrentIndex(
      prevIndex => (prevIndex - 1 + photos.length) % photos.length
    )
  }

  const handleNext = () => {
    setCurrentIndex(prevIndex => (prevIndex + 1) % photos.length)
  }

  const handleSwipe = deltaX => {
    const sensitivity = 100
    if (deltaX > sensitivity) {
      handlePrev()
    } else if (deltaX < -sensitivity) {
      handleNext()
    }
  }

  const handleDotClick = index => {
    setCurrentIndex(index)
  }

  return (
    <div className={clsx('mobile-photo-slider-container', className)}>
      <div
        className="slider-wrapper"
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
        onClick={() => setIsOpen(true)}
        {...handlers}
      >
        {photos.map((photo, index) => (
          <img
            key={index}
            src={photo}
            alt={index + 'photo'}
            className="slide"
          />
        ))}
      </div>

      <div className="dots-container">
        {photos.map((_, index) => (
          <div
            key={index}
            className={`dot ${index === currentIndex ? 'active' : ''}`}
            onClick={() => handleDotClick(index)}
          />
        ))}
      </div>

      <button className="prev-btn" onClick={handlePrev}>
        <ArrowLeftIcon />
      </button>
      <button className="next-btn" onClick={handleNext}>
        <ArrowRightIcon />
      </button>
      {children}
      {isOpen && (
        <Lightbox
          reactModalStyle={{
            content: { zIndex: 1400 },
            overlay: { zIndex: 1400 }
          }}
          mainSrc={photos?.[currentIndex]}
          nextSrc={photos?.[(currentIndex + 1) % photos?.length]}
          prevSrc={
            photos?.[(currentIndex + photos?.length - 1) % photos?.length]
          }
          onCloseRequest={() => setIsOpen(false)}
          onMovePrevRequest={handlePrev}
          onMoveNextRequest={handleNext}
        />
      )}
    </div>
  )
}

export default MobilePhotoSlider
